if ($(window).width() > 991) {
	$(".cards-col").on({
		mouseover: function(e) {
			$(this).addClass('cards-col-active').siblings().removeClass('cards-col-active');
		},
	});

	// Parallax effect
	var onScroll = function() {
		var scrollTop = $(this).scrollTop();
		$('.parallax-image').each(function(index, elem) {
		  var $elem = $(elem);
		  $elem.find('img.par-effect').css('top', scrollTop - $elem.offset().top);
		});
	};
	onScroll.apply(window);
	$(window).on('scroll', onScroll);
}

var swiper1home = new Swiper(".home-shop-slider", {
	slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
	pagination: {
	  el: ".swiper-pagination",
	  clickable: true,
	},
});

$(window).on("load resize", function () {
	if ($(window).width() < 992) {
	 var newposition = $(".home-shop-slider .swiper-slide span").outerHeight();
	 $(".home-shop-slider .swiper-pagination").css({"bottom":newposition+16});
	} else {
	 $(".home-shop-slider .swiper-pagination").removeAttr("style");
	}
});